<div>
  <div *ngIf="loading" class="center">
    <div class="ring"></div>
  </div>
  <div *ngIf="!loading">
    <div class="empty-box">
      <img src="assets/img/open-box.svg" alt="">
      <span *ngIf="msg === ''"> {{title}} وجود ندارد.</span>
      <span *ngIf="msg !== ''"> {{msg}}</span>
    </div>
  </div>
</div>